export default "__VITE_ASSET__beb507fe__"